import { CollectionAdapter } from "../../../main/adapters/CollectionAdapter/CollectionAdapter";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";
const SeriesAccountingAnalyticsCollection = new Mongo.Collection(
    "SeriesAccountingAnalyticsCollection",
    {
        connection: null
    }
);

export class SeriesAccountingAnalytics extends CollectionAdapter {
    constructor() {
        super(SeriesAccountingAnalyticsCollection);
    }

    generateTypeGrouped(
        { listFields, field, baseId, unit, func, refereceId },
        typeReturn = false
    ) {
        const serieIds = [];

        const _modeler = (_id, name, value) => {
            return {
                _id,
                name,
                operation: {
                    func: func || "countPercentage",
                    value,
                    group: field
                },
                unit: unit || "percentage",
                refereceId
            };
        };

        const _idGenerate = (value) =>
            `${baseId}_${NormalizeString.normalizeUpperCaseNd(value)}`;

        listFields.forEach((fieldItem) => {
            let _id = null;
            let serie = null;

            if (typeof fieldItem !== "string") {
                _id = _idGenerate(fieldItem.model);

                serie = _modeler(_id, fieldItem.value, fieldItem.model);
            } else {
                _id = _idGenerate(fieldItem);

                serie = _modeler(_id, fieldItem, fieldItem);
            }

            if (typeReturn) {
                serieIds.push({
                    _id,
                    name: serie.name,
                    refereceId: serie.refereceId
                });
            } else {
                serieIds.push(_id);
            }

            this.create(serie);
        });

        return serieIds;
    }

    default() {
        const series = [
            {
                _id: "SCORE_ACCOUNTINGS_HIGH",
                name: "Score Alto",
                type: "compound",
                path: "high",
                operation: { func: "scoreAccountings" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTINGS_MEDIUM",
                name: "Score Médio",
                type: "compound",
                path: "medium",
                operation: { func: "scoreAccountings" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTINGS_LOW",
                name: "Score Baixo",
                type: "compound",
                path: "low",
                operation: { func: "scoreAccountings" },
                unit: "int"
            },

            {
                _id: "BILLING_ACCOUNTINGS_HIGH",
                name: "Score Alto",
                type: "compound",
                path: "high",
                operation: { func: "billingAccountings" },
                unit: "currency"
            },
            {
                _id: "BILLING_ACCOUNTINGS_MEDIUM",
                name: "Score Médio",
                type: "compound",
                path: "medium",
                operation: { func: "billingAccountings" },
                unit: "currency"
            },
            {
                _id: "BILLING_ACCOUNTINGS_LOW",
                name: "Score Baixo",
                type: "compound",
                path: "low",
                operation: { func: "billingAccountings" },
                unit: "currency"
            },
            {
                _id: "SUM_BILLING_RISK_LOW",
                name: "Score Baixo",
                type: "compound",
                path: "v",
                operation: { func: "billingRiskLow" },
                unit: "currency"
            },
            {
                _id: "SUM_BILLING_RISK_MEDIUM",
                name: "Score Médio",
                type: "compound",
                path: "v",
                operation: { func: "billingRiskMedium" },
                unit: "currency"
            },
            {
                _id: "SUM_BILLING_RISK_HIGH",
                name: "Score Alto",
                type: "compound",
                path: "v",
                operation: { func: "billingRiskHigh" },
                unit: "currency"
            },
            {
                _id: "CUSTOMER_ENGAGEMENT_INSERTED",
                name: "Inseriu dados",
                type: "compound",
                path: "total",
                operation: { func: "customerEngagement" },
                unit: "int"
            },
            {
                _id: "CUSTOMER_ENGAGEMENT_SHARED",
                name: "Compartilhou Relatório",
                type: "compound",
                path: "total",
                operation: { func: "customerEngagement" },
                unit: "int"
            },
            {
                _id: "CUSTOMER_ENGAGEMENT_DOWNLOADED",
                name: "Baixou Relatório",
                type: "compound",
                path: "total",
                operation: { func: "customerEngagement" },
                unit: "int"
            },
            {
                _id: "CUSTOMER_ENGAGEMENT_VIEWED",
                name: "Visualizou Relatório",
                type: "compound",
                path: "total",
                operation: { func: "customerEngagement" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTING",
                name: "Score",
                type: "compound",
                path: "total",
                operation: { func: "scoreAccounting" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTING_HIGH",
                name: "Score Alto",
                path: "high",
                type: "compound",
                operation: { func: "scoreAccountingByType" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTING_MEDIUM",
                name: "Score Médio",
                path: "medium",
                type: "compound",
                operation: { func: "scoreAccountingByType" },
                unit: "int"
            },
            {
                _id: "SCORE_ACCOUNTING_LOW",
                name: "Score Baixo",
                path: "low",
                type: "compound",
                operation: { func: "scoreAccountingByType" },
                unit: "int"
            },
            {
                _id: "LAST_FEES_BY_MONTH",
                name: "Honorário",
                type: "compound",
                operation: { func: "sumFeesLast" },
                unit: "currency"
            },
            {
                _id: "SUM_FEES_BY_MONTH",
                name: "Honorário",
                type: "compound",
                operation: { func: "sumFeesByMonth" },
                unit: "currency"
            },
            {
                _id: "COUNT_COMPANIES_BY_MONTH",
                name: "Número de Clientes",
                type: "compound",
                operation: {
                    func: "count"
                },
                unit: "number"
            },
            {
                _id: "SUM_AVARAGETICKET_BY_MONTH",
                name: "Ticket Médio",
                type: "compound",
                operation: {
                    func: "calcAverageticket"
                },
                unit: "currency"
            },
            {
                _id: "SUM_FEES_BY_TAXATION_MONTH",
                name: "Honorários",
                type: "compound",
                operation: { func: "sumFeesByMonth" },
                unit: "currency"
            },
            {
                _id: "COUNT_COMPANIES_BY_TAXATION_MONTH",
                name: "Número de Clientes",
                type: "compound",
                operation: {
                    func: "count"
                },
                unit: "number"
            },

            {
                _id: "SUM_FEES_BY_SEGMENTGROUP_MONTH",
                name: "Honorários",
                type: "compound",
                operation: { func: "sumFeesByMonth" },
                unit: "currency"
            },
            {
                _id: "COUNT_COMPANIES_BY_SEGMENTGROUP_MONTH",
                name: "Número de Clientes",
                type: "compound",
                operation: {
                    func: "count"
                },
                unit: "number"
            },

            {
                _id: "SUM_FEES_BY_CATEGORY_MONTH",
                name: "Honorários",
                type: "compound",
                operation: { func: "sumFeesByMonth" },
                unit: "currency"
            },
            {
                _id: "COUNT_COMPANIES_BY_CATEGORY_MONTH",
                name: "Número de Clientes",
                type: "compound",
                operation: {
                    func: "count"
                },
                unit: "number"
            },

            {
                _id: "TOTAL_RECEITAS_BY_MONTH",
                name: "Total das Receitas",
                type: "compound",
                operation: {
                    func: "sumKPI",
                    group: "RECEITAS"
                },
                unit: "currency",
                refereceId: "RECEITAS"
            },
            {
                _id: "AVARAGE_RECEITAS_BY_MONTH",
                name: "Média das Receita",
                type: "compound",
                operation: {
                    func: "avaregeKPI",
                    group: "RECEITAS"
                },
                unit: "currency",
                refereceId: "RECEITAS"
            },

            {
                _id: "TOTAL_IMPOSTOS_BY_MONTH",
                name: "Total dos Impostos",
                type: "compound",
                operation: {
                    func: "sumKPI",
                    group: "IMPOSTOS"
                },
                unit: "currency",
                refereceId: "IMPOSTOS"
            },
            {
                _id: "AVARAGE_IMPOSTOS_BY_MONTH",
                name: "Média dos Impostos",
                type: "compound",
                operation: {
                    func: "avaregeKPI",
                    group: "IMPOSTOS"
                },
                unit: "currency",
                refereceId: "IMPOSTOS"
            },
            {
                _id: "TOTAL_NUMERO_FUNCIONARIO_BY_MONTH",
                name: "Total dos Funcionarios",
                type: "compound",
                operation: {
                    func: "sumKPI",
                    group: "NUMERO DE FUNCIONARIOS"
                },
                unit: "number",
                refereceId: "NUMERO DE FUNCIONARIOS"
            },
            {
                _id: "AVARAGE_NUMERO_FUNCIONARIO_BY_MONTH",
                name: "Média dos Funcionarios",
                type: "compound",
                operation: {
                    func: "avaregeKPI",
                    group: "NUMERO DE FUNCIONARIOS"
                },
                unit: "number",
                refereceId: "NUMERO DE FUNCIONARIOS"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_BRONZE_TOTAL",
                name: "Bronze",
                type: "compound",
                path: "Bronze",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_BRONZE_0",
                name: "Bronze 0",
                type: "compound",
                path: "Bronze 0",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_BRONZE_1",
                name: "Bronze 1",
                type: "compound",
                path: "Bronze 1",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_BRONZE_2",
                name: "Bronze 2+",
                type: "compound",
                path: "Bronze 2",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_PRATA",
                name: "Prata",
                type: "compound",
                path: "Prata",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_OURO",
                name: "Ouro",
                type: "compound",
                path: "Ouro",
                operation: { func: "impactAccountings" },
                unit: "int"
            },
            {
                _id: "IMPACT_ACCOUNTINGS_EMBAIXADOR",
                name: "Embaixador",
                type: "compound",
                path: "Embaixador",
                operation: { func: "impactAccountings" },
                unit: "int"
            }
        ];

        this.createMany(series);
    }
}
